import React from "react";

import ActionDropdown from "components/Common/ActionDropdown";
import { Steward, LinkText } from "components/Common/TableStyle";

export const COLUMNS = [
  "Domain Name",
  "Description",
  "Drafter",
  "Approver",
  "CDEs",
  "Action",
];

export const COLUMN_DATA = (handleEdit, handleDelete, userPermissions) => [
  {
    dataIndex: "name",
    key: "name",
    title: "Domain Name",
    width: "40%",
    fixed: "left",
    render: (text, row) => (
      <LinkText text={text} link={row.id} state={{ parent: text }} />
    ),
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    width: "65%",
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "Drafter",
    width: "35%",
    key: "drafter",
    dataIndex: "drafter",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Approver",
    width: "35%",
    key: "approver",
    dataIndex: "approver",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    dataIndex: "cdes",
    key: "cdes",
    title: "# CDE",
    width: "20%",
    align: "center",
    render: text => (text ? text : 0),
  },
  {
    dataIndex: "data_sources",
    key: "data_sources",
    title: "# Data Source",
    width: "35%",
    align: "center",
    render: text => (text ? text : 0),
  },
  {
    key: "action",
    dataIndex: "action",
    title: "Action",
    width: "25%",
    align: "center",
    render: (_, record) => (
      <ActionDropdown
        editProps={{
          onClick: () => handleEdit(record),
          "data-cy": "domain-edit-button",
        }}
        deleteProps={{
          onClick: () => handleDelete(record),
          "data-cy": "domain-delete-button",
        }}
        userPermissions={userPermissions}
      />
    ),
  },
];
